//  IMPORTANT:
//  This file is generated. Your changes will be lost.
//  Source Table: [dbo].[Role]

import { LookupTableEntry } from "src/app/shared/models/lookup-table-entry";
import { SelectDropdownOption } from "src/app/shared/components/forms/form-field/form-field.component"

export enum RoleEnum {
  SystemAdmin = 1,
  NoAccess = 2,
  Normal = 3,
  PendingLogin = 4,
  ContentEditor = 5
}

export const Roles: LookupTableEntry[]  = [
  { Name: "SystemAdmin", DisplayName: "System Administrator", Value: 1, SortOrder: 10 },
  { Name: "NoAccess", DisplayName: "No Access", Value: 2, SortOrder: 20 },
  { Name: "Normal", DisplayName: "Normal", Value: 3, SortOrder: 30 },
  { Name: "PendingLogin", DisplayName: "Pending Login", Value: 4, SortOrder: 40 },
  { Name: "ContentEditor", DisplayName: "Content Editor", Value: 5, SortOrder: 50 }
];
export const RolesAsSelectDropdownOptions = Roles.map((x) => ({ Value: x.Value, Label: x.DisplayName, SortOrder: x.SortOrder } as SelectDropdownOption));
